import { safeId } from "@otto-ec/otto-components-utils/utils/safeId";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const ensureId = (element: HTMLElement): string => (element.id ||= safeId(undefined, "oc-"));
